var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "delivery-address-name",
      on: {
        click: function($event) {
          _vm.isOpened = !_vm.isOpened
        },
        touchstart: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("ui-input", {
        ref: "input",
        staticClass: "delivery-address-name__input",
        attrs: {
          value: _vm.disabled ? "" : _vm.innerValue,
          label: _vm.inputLabel,
          placeholder: _vm.isSaveAddress
            ? "Например, «Офис»"
            : "Выберите адрес",
          validate: _vm.isSaveAddress ? "address_name" : "",
          disabled: _vm.disabled,
          readonly:
            !!_vm.selectedAddressId ||
            (_vm.isShowSaveAddress && !_vm.isSaveAddress)
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "append",
            fn: function() {
              return [
                _vm.isAddresses
                  ? _c("chevron-animated", {
                      staticClass: "delivery-address-name__chevron",
                      attrs: { reverse: _vm.isOpened }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm.isAddresses
        ? _c(
            "div",
            { staticClass: "delivery-address-name__options" },
            [
              _c(
                "ui-dropdown",
                {
                  attrs: { visible: _vm.isOpened },
                  on: {
                    "on-close": function($event) {
                      _vm.isOpened = false
                    }
                  }
                },
                _vm._l(_vm.options, function(option) {
                  return _c(
                    "div",
                    {
                      key: option.value,
                      staticClass: "delivery-address-name__options-item",
                      on: {
                        click: function($event) {
                          return _vm.onChange(option)
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(option.name))]),
                      option.value === _vm.selectedAddressId
                        ? _c("f-sprite-icon", {
                            attrs: {
                              "icon-link": _vm.$options.icons.IconCheck.id
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }